// extracted by mini-css-extract-plugin
export var searchForm = "search-module--search-form--1p1Og";
export var searchField = "search-module--search-field--1v4Uv";
export var searchIcon = "search-module--search-icon--MRtIj";